<template>

    <div>
        <div class="app-panel">
            <div v-if="indexModel.isLoaded()">
                <table class="w-full">
                    <thead>
                    <tr class="pb-2">
                        <th class="lg:w-2/6 font-medium text-left pl-4">Product</th>
                        <th class="hidden lg:table-cell font-medium">Discount</th>
                        <th class="font-medium">Value</th>
                        <th class="font-medium">Reference</th>
                        <th class="font-medium">Details</th>
                        <th class="font-medium">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody >
                    <tr class="colored-row my-2 text-sm" v-for="(item, index) in indexModel.getData()">
                        <td>
                            <div class="flex items-center">
                                <div class="hidden lg:flex font-medium">
                                    #{{ index + 1 }}
                                </div>
                                <div class="px-2">
                                    <img :src="item.product_image" alt="No Image" class="w-12 lg:w-20 bg-contain my-2">
                                </div>
                                <div>
                                    <span class="flex font-medium">
                                        {{ item.product_name }}
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-1 text-brand-500" viewBox="0 0 20 20" fill="currentColor" v-if="item.item_status === 'complete'">
                                            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                                        </svg>
                                    </span>
                                    <p class="hidden lg:flex text-xs text-gray-500">{{ item.uuid }}</p>
                                </div>
                            </div>
                        </td>
                        <td class="hidden lg:table-cell text-center font-medium text-indigo-500">
                            <span class="text-lg">{{ item.discount / 100 }}</span>%
                        </td>
                        <td class="text-center">
                            <span class="block">{{ formatCurrency(item.currency, item.product_gross / 100) }}</span>
                            <p class="text-xs text-gray-500">
                                {{ formatCurrency(item.currency, item.product_net / 100) }}
                            </p>
                        </td>
                        <td class="text-center">

                            <a :href="item.processor_view_order_url" target="_blank" v-if="isAdmin && item.processor_view_order_url">
                                <span class="text-center">{{ item.processor_reference}}</span>
                            </a>
                            <span v-else class="text-center">{{ item.processor_reference}}</span>
                        </td>
                        <td class="text-center">
                            <div class="">Code: <span v-if="item.masked_code">{{ item.masked_code}}</span><span v-else >-</span></div>
                            <div class="text-xs text-gray-500">Serial: <span v-if="item.details.serial">{{ item.details.serial }}</span><span v-else >-</span></div>
                            <div class="text-xs text-gray-500" v-if="item.details.masked_pan">PAN: {{ item.details.masked_pan }}</div>
                            <div class="text-xs text-gray-500">Job ID: <span v-if="item.processor_job_id">{{ item.processor_job_id }}</span><span v-else >-</span></div>
                        </td>
                        <td class="flex justify-end text-center">
                            <a :href="item.details.url" target="_blank" class="btn-outline text-xs my-4" v-if="item.product_type !== 'reload' && item.item_status === 'complete' && item.details && item.details.url">
                                Show Code
                            </a>
                            <span class="flex items-center text-xs font-medium py-6 text-gray-600" v-else-if="item.item_status === 'processing'">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                Item Processing
                            </span>
                            <span class="flex items-center text-xs font-medium py-6 text-gray-600" v-else-if="item.item_status === 'refunded'">
                                Item Refunded/Cancelled
                            </span>
                            <span v-else>&nbsp</span>
                            <ConfirmationModal v-if="isAdmin && item.is_refundable && item.item_status !== 'refunded'" button_classes="btn-error text-xs my-4 ml-2" class="inline" button_text="Refund" @confirmModal="refund(item.uuid, index)">
                                <div class="mt-3 text-center sm:mt-5">
                                    <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                                        Refund/Cancel {{ item.product_name }}?
                                    </h3>
                                    <div class="mt-2">
                                        <p class="text-sm text-gray-500" v-if="$parent.order.payment_type !== 'unlimited'">
                                            {{ formatCurrency(item.currency, item.refundable_amount / 100) }} will be refunded.
                                        </p>
                                    </div>
                                </div>
                            </ConfirmationModal>
                        </td>
                    </tr>
                    <tr class="py-6 text-xs font-medium">
                        <infinite-loading @infinite="infiniteHandler">
                            <div slot="spinner">Loading...</div>
                            <div slot="no-more">No more items</div>
                        </infinite-loading>
                    </tr>
                    </tbody>
                </table>
            </div>
            <Loading v-else></Loading>
        </div>
        <div class="flex mt-6 justify-end">
            <div class="flex border-l-4 border-error-500 bg-error-50 text-gray-700 px-4 py-1 rounded tracking-wide shadow items-center text-error-400" v-if="value.hasError()">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
                <p class="text-error-500 text-sm" v-html="value.getErrorMessage()"></p>
            </div>
        </div>
    </div>

</template>

<script>
import Loading from "../Support/Loading";
import ConfirmationModal from "../Support/ConfirmationModal";
import {FormattingMixin} from "../../support/mixins";
import {ShowOrderItemIndex} from "../../app/Order/ShowOrderItemIndex";
import InfiniteLoading from "vue-infinite-loading";

export default {
    name: "ShowOrderItems",
    mixins: [FormattingMixin],
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    components: {
        Loading,
        ConfirmationModal,
        InfiniteLoading,
    },
    data() {
        return {
            loaded: true,
            indexModel: new ShowOrderItemIndex(this.value.reference),
        }
    },
    mounted() {
        this.indexModel.load();
    },
    computed: {
        isAdmin() {
            return this.$parent.$parent.isAdmin;
        }
    },
    methods: {
        refund(itemUuid, index) {
            let vm = this;

            const originalStatus = vm.indexModel.getData()[index].item_status;

            vm.indexModel.getData()[index].item_status = 'refunded';

            this.value.refundItem(itemUuid).then(result => {
                vm.indexModel.getData()[index].item_status = result.data.data.item_status;
                vm.value.order.status = result.data.data.order_status;
                vm.$forceUpdate();
            }).catch(() => {
                vm.indexModel.getData()[index].item_status = originalStatus;
                vm.$forceUpdate();
            });
        },
        infiniteHandler($state) {
            this.indexModel.infiniteLoadingHandler($state);
        },
    }
}
</script>
